import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../services/api';
import '../styles/EditStory.css';

function EditStory() {
  const location = useLocation();
  const navigate = useNavigate();
  const MAX_CHARACTERS = 100000;

  const [content, setContent] = useState(location.state?.content || '');
  const [bookTitle, setBookTitle] = useState(location.state?.title || 'Adsız Bölüm 1');
  const [bookId] = useState(location.state?.bookId);
  const [chapterId, setChapterId] = useState(location.state?.chapterId);
  const [initialLoad, setInitialLoad] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (!bookId) {
      console.error('book_id eksik!');
      return;
    }

    const fetchChapter = async () => {
      if (chapterId && initialLoad) {
        try {
          const token = localStorage.getItem('token');
          const response = await api.get(`/stories/chapters/${chapterId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setContent(response.data.content || '');
          setBookTitle(response.data.title || 'Adsız Bölüm 1');
          setIsPublished(response.data.is_published || false);
          setInitialLoad(false);
        } catch (error) {
          console.error('Bölüm detayları getirilirken hata oluştu:', error);
        }
      }
    };
    fetchChapter();
  }, [bookId, chapterId, navigate, initialLoad]);

  const handleTitleChange = (e) => {
    setBookTitle(e.target.value); // No trim here to allow spaces
  };

  const handleContentChange = (e) => {
    const newText = e.target.value;
    if (newText.length <= MAX_CHARACTERS) {
      setContent(newText);
    } else {
      alert('Karakter sınırını aştınız. Lütfen daha kısa bir metin girin.');
    }
  };

  const handlePublishToggle = () => {
    setIsModalOpen(true);
  };

  const handleSave = async () => {
    const trimmedTitle = bookTitle.trim(); // Trim only when saving
    const trimmedContent = content.trim();

    if (!trimmedTitle || !trimmedContent) {
      alert('Başlık ve içerik boş olamaz.');
      return;
    }

    await saveChapter(false);
  };

  const saveChapter = async (publishStatus) => {
    const trimmedTitle = bookTitle.trim();
    const trimmedContent = content.trim();

    try {
      const chapterData = {
        book_id: bookId,
        chapter_id: chapterId,
        title: trimmedTitle,
        content: trimmedContent,
        is_published: publishStatus,
      };
      const token = localStorage.getItem('token');
      const response = await api.post('/stories/chapters', chapterData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setChapterId(response.data.chapter_id);
      setIsPublished(publishStatus);
      setSuccessMessage(publishStatus ? 'Bölüm başarıyla yayımlandı!' : 'Bölüm başarıyla kaydedildi!');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error(
        error.message.includes('yayımlanırken') ? 'Hikaye yayımlanırken hata.' : 'Hikaye kaydedilirken hata.'
      );
      alert('Hikaye kaydedilirken hata oluştu.');
    }
  };

  const handlePreview = () => {
    navigate(`/preview`, {
      state: {
        title: bookTitle,
        content: content,
        storyId: bookId,
        chapterId: chapterId, // Ensure chapterId is passed
      },
    });
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleConfirm = async () => {
    setIsModalOpen(false);
    await saveChapter(!isPublished);
  };

  if (!bookId) {
    return null;
  }

  return (
    <div className="edit-story-container">
      <header className="edit-story-header">
        <button className="back-button" onClick={handleGoBack}>
          {'<'}
        </button>
        <h1>{bookTitle}</h1>
        <div className="header-buttons">
          <button className="publish-button" onClick={handlePublishToggle}>
            {isPublished ? 'Yayımdan Kaldır' : 'Yayımla'}
          </button>
          <button className="save-button" onClick={handleSave}>Kaydet</button>
          <button className="preview-button" onClick={handlePreview}>Önizleme</button>
        </div>
      </header>
      <main className="edit-story-main">
        <div className="toolbar">
          <input
            type="text"
            className="book-title-input"
            placeholder="Bölüm İsmi Giriniz"
            value={bookTitle}
            onChange={handleTitleChange}
          />
        </div>
        <textarea
          className="story-editor"
          value={content}
          onChange={handleContentChange}
          placeholder="Metninizi yazın"
          maxLength={MAX_CHARACTERS}
        />
      </main>
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>
              Bu hikayeyi {isPublished ? 'yayımdan kaldırmak' : 'yayımlamak'}
              <br /> istediğinize emin misiniz?
            </h2>
            <div className="modal-buttons">
              <button onClick={handleConfirm} className="confirm-btn">Evet</button>
              <button onClick={() => setIsModalOpen(false)} className="cancel-btn">Hayır</button>
            </div>
          </div>
        </div>
      )}
      {successMessage && (
        <div className="success-message">
          {successMessage}
        </div>
      )}
    </div>
  );
}

export default EditStory;
